import { Component, EventEmitter, input, Input, Output, ViewChild } from '@angular/core';
import { DialogComponent } from "../dialog/components/dialog.component";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SelectedItem } from '../models/selected-item.interface';

@Component({
  selector: 'cec-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
  standalone: true,
  imports: [DialogComponent, MatInputModule, MatFormFieldModule, FormsModule, TranslateModule],
})
export class InfoDialogComponent {

    /** Dialog component reference to access */
    @ViewChild(DialogComponent) 
    protected dialog!: DialogComponent;

    /** Label for textarea field */
    @Input()
    protected textAreaLabelKey: string | undefined = undefined;

    /** Organizer competitor flag */
    protected isOrganizer = false;

    /** Entity id reference */
    protected id: number | undefined = undefined;

    /** Provided value reference */
    protected message: string | undefined = undefined;

    protected values: unknown[] | undefined = undefined;

    protected type: 'message' | 'list' | 'custom' = 'message';

    public width = input('25rem');

    public headerText = input<string | null>(null);

    public headerKey = input<string | null>(null);

    public subTitle = input<string | null>(null);

    /** Returns the value from textarea field */
    @Output()
    public onButtonClicked = new EventEmitter<SelectedItem | undefined>();

    /**
     * Shows the confirmation dialog
     */
    public show(message: string, id?: number, isOrganizer = false): void {
        this.type = 'message';
        this.message = message;
        this.id = id;
        this.isOrganizer = isOrganizer;
        this.dialog.show();
    }

    /**
     * Shows the confirmation dialog
     */
    public showList(values: unknown[], id?: number, isOrganizer = false): void {
        this.type = 'list';
        this.values = values;
        this.id = id;
        this.isOrganizer = isOrganizer;
        this.dialog.show();
    }

    /**
     * Shows the confirmation dialog
     */
    public showCustom(values: unknown[], id?: number, isOrganizer = false): void {
        this.type = 'custom';
        this.values = values;
        this.id = id;
        this.isOrganizer = isOrganizer;
        this.dialog.show();
    }

    /**
     * Returns the value from textarea field
     * @param success the confirmation status
     */
    protected onClickButton(success: boolean): void {

        /** basic competitor should not edit the message */
        if (!this.isOrganizer) {
            return;
        }
        
        /** if user edited the value, return value */
        if (success) {
            this.onButtonClicked.emit({
                value: this.id,
                text: this.message
            });
            return;
        }

        /** else return undefined */
        this.onButtonClicked.emit(undefined);
    }
}
